import { TrainerProgram } from 'hevy-shared';
import { makeAutoObservable } from 'mobx';
import API from 'utils/API';

export class Trainer {
  private _program: TrainerProgram | undefined = undefined;

  constructor() {
    makeAutoObservable(this);
  }

  get program(): TrainerProgram | undefined {
    return this._program;
  }

  fetch = async () => {
    try {
      const result = await API.getHevyTrainerProgram();
      this._program = result.data.program;
    } catch (e) {
      this._program = undefined;
    }
  };
}
